import { Component, OnInit, ViewChild, Input, EventEmitter, Output, OnDestroy } from '@angular/core';

// Serivicios locales
import { SubSeriesDocumentaryDataService } from './shared/subseries-documentary-data.service';
import { SubSeriesDocumentaryFormService } from './shared/subseries-documentary-form.service';
import { SubSeriesDocumentaryConfigService } from './shared/subseries-documentary-config.service';

// Modelos
import {
  SeriePredeterminada,
  SubSeriePredeterminada,
  Const
} from '@app/shared';

import { ConfirmComponent, BaseControl } from '@app/shared';
import { LocalDataSource } from 'ng2-smart-table';
import { ToastrService } from 'ngx-toastr';

import { filter, findIndex } from 'lodash';

// Tipo de dato
import { Action } from '../documents.component';
import { AuthenticationService } from '@app/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-subseries-documentary',
  templateUrl: './subseries-documentary.component.html',
  styleUrls: ['./subseries-documentary.component.scss'],
  providers: [
    SubSeriesDocumentaryDataService,
    SubSeriesDocumentaryFormService
  ]
})
export class SubSeriesDocumentaryComponent implements OnInit, OnDestroy {

  // Entrada de las series
  @Input() set series(s: SeriePredeterminada[]) {
    this._series = s;
    this.loadingSeriesDocuments();
  }
  // Entrada de las subseries
  @Input() set subseries(s: SubSeriePredeterminada[]) {
    this._subseries = s;
    this.loadingSubSeriesDocuments();
  }
  // Series para el select
  seriesList: SeriePredeterminada[] = [];
  // Array de subseries con filtro según la serie seleccionada
  arraySubseriesFilter: LocalDataSource;
  // Define la accion a realizar en el formulario
  actionForm = '';
  // Pregunta de la modal de confirmaciones
  question = '';
  // Define cuando mostrar la tabla principal o el formulario
  formOpen = false;
  // Define si la subserie en accion es para editar o agregar
  subserieEdit = true;
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    created: false,
    update: false,
    delete: false,
  };
  // Configuracion de la tabla
  settings = {};
  // Datos para llenar la tabla
  sourceData: SubSeriePredeterminada[] = [];
  // Contiene la subserie seleccionado
  subserieSelect: SubSeriePredeterminada;
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Evento de salida que notifica ala padre para actualizar las subseries
  @Output() refreshSubSeries: EventEmitter<Action> = new EventEmitter();
  // Subseries
  private _subseries: SubSeriePredeterminada[];
  // Series
  private _series: SeriePredeterminada[] = [];
  // id de la serie seleccionada
  private _idSerieSelect: any;

  constructor(
    private ssdds: SubSeriesDocumentaryDataService,
    private ssdfs: SubSeriesDocumentaryFormService,
    private toastr: ToastrService,
    private as: AuthenticationService) { }

  ngOnInit() {
    // Determina los permisos del usuario en sesion
    this.activateAction.created = this.as.confirmPermission(
      Const.types_permissions.administrationDocument,
      Const.types_action_permissions.created
    );
    this.activateAction.update = this.as.confirmPermission(
      Const.types_permissions.administrationDocument,
      Const.types_action_permissions.update
    );
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.administrationDocument,
      Const.types_action_permissions.delete
    );
    const configTable = new SubSeriesDocumentaryConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      this.defineActionCondictions(res.action, res.data);
    });
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  get series(): SeriePredeterminada[] {
    return this._series;
  }

  get subseries(): SubSeriePredeterminada[] {
    return this._subseries;
  }

  /**
   * Obteniendo datos y filtrando subseries por serie seleccionada
   *
   * @param {SeriePredeterminada} [data]
   * @memberof SubSeriesDocumentaryComponent
   */
  set idSerieSelect(value: any) {
    if (value !== this.idSerieSelect) {
      this._idSerieSelect = value;
      this.updateArrayFilter();
    }
  }

  get idSerieSelect(): any {
    return this._idSerieSelect;
  }

  /**
   * Cargar las series
   *
   * @memberof SubSeriesDocumentaryComponent
   */
  loadingSeriesDocuments() {
    this.seriesList = this.series;
    if (this.idSerieSelect) {
      const valid = findIndex(this.series, { 'id': this.idSerieSelect });
      if (valid === -1) {
        this.idSerieSelect = null;
      }
    }
  }

  /**
   * Cargar todas las subseries
   *
   * @memberof SubSeriesDocumentaryComponent
   */
  loadingSubSeriesDocuments() {
    this.sourceData = this.subseries;
    this.updateArrayFilter();
  }

  /**
   * Condiciona acción ha realzar
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof SubSeriesDocumentaryComponent
   */
  defineActionCondictions(action: 'add' | 'update' | 'delete' = 'add', data?: any) {
    switch (action) {
      case 'add':
        if (this.activateAction.created) {
          this.formOpen = true;
          this.subserieEdit = false;
          this.actionForm = 'Agregar';
          this.controls = this.ssdfs.getFormSubSerie();
        } else {
          this.toastr.error('Usted no posee permisos para agregar las subseries del sistema', 'Permiso denegado');
        }
        break;
      case 'update':
        if (this.activateAction.update) {
          this.formOpen = true;
          this.subserieEdit = true;
          this.actionForm = 'Modificar';
          this.subserieSelect = data;
          this.controls = this.ssdfs.getFormSubSerie(this.subserieSelect);
        } else {
          this.toastr.error('Usted no posee permisos para modificar las subseries del sistema', 'Permiso denegado');
        }
        break;
      case 'delete':
        if (this.activateAction.delete) {
          this.subserieSelect = data;
          this.question = '¿Realmente desea eliminar la subserie?';
          this.confirm.open();
        } else {
          this.toastr.error('Usted no posee permisos para eliminar las subseries del sistema', 'Permiso denegado');
        }
        break;
    }
  }

  /**
   * Activa modal de confirmación
   *
   * @param {boolean} res
   * @memberof SubSeriesDocumentaryComponent
   */
  actionComfirm(res: boolean) {
    if (res) {
      this.deleteSubSerie();
    }
    this.question = '';
  }

  /**
   * Cierra la vista del formulario de creacion o edicion de una subserie
   *
   * @memberof SubSeriesDocumentaryComponent
   */
  closeFormSubSerie() {
    this.actionForm = '';
    this.question = '';
    this.formOpen = false;
    this.subserieEdit = false;
    this.subserieSelect = null;
  }

  /**
   * Guarda o edita una subserie en el sistema
   *
   * @param {*} data
   * @memberof SubSeriesDocumentaryComponent
   */
  sended(data: any) {
    if (data) {
      let subserie: SubSeriePredeterminada = new SubSeriePredeterminada();
      subserie = {
        nombre: data.nombre,
        codigo: data.codigo,
        serie: this.idSerieSelect
      };

      if (this.subserieSelect) {
          this.ssdds.updateSubserie(this.subserieSelect.id, subserie).then(() => {
          this.closeFormSubSerie();
          this.refreshSubSeries.emit('update');
        });
      } else {
        this.ssdds.addSubserie(subserie).then(() => {
          this.closeFormSubSerie();
          this.refreshSubSeries.emit('add');
        });
      }

    }
  }

  /**
   * Elimina una subserie del sistema
   *
   * @private
   * @memberof SubSeriesDocumentaryComponent
   */
  private deleteSubSerie() {
    this.ssdds.deleteSubserie(this.subserieSelect.id).then(() => {
      this.closeFormSubSerie();
      this.refreshSubSeries.emit('delete');
    }).catch(() => {
      this.closeFormSubSerie();
    });
  }

  /**
   * Actualizar array que filtra según la serie seleccionada
   *
   * @private
   * @memberof SubSeriesDocumentaryComponent
   */
  private updateArrayFilter() {
    if (this.idSerieSelect) {
      this.arraySubseriesFilter = new LocalDataSource(
        filter(this.sourceData, row => row.serie.id === this.idSerieSelect)
      );
      this.arraySubseriesFilter.refresh();
    } else if (this.arraySubseriesFilter) {
      this.arraySubseriesFilter.empty();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/documents/subseries-documentary/subseries-documentary.component.ts